import { gql } from '@apollo/client'

export const GET_USERS = gql`
  query GetUsers {
    users {
      id
      email
      first_name
      last_name
      branch
      site_admin
      department {
        id
        name
      }
      user_role {
        id
        name
        scope
      }
    }
  }
`

export const GET_USER = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      id
      email
      first_name
      last_name
      branch
      department {
        id
        name
      }
      user_role {
        id
        name
        scope
      }
    }
  }
`

export const CREATE_USER = gql`
  mutation CreateUser($input: UserCreateInput!) {
    createUser(input: $input) {
      email
      first_name
      last_name
      branch
      department {
        id
      }
      user_role {
        id
      }
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser($id: ID!, $input: UserUpdateInput!) {
    updateUser(id: $id, input: $input) {
      id
      email
      first_name
      last_name
      branch
      site_admin
      department {
        id
      }
      user_role {
        id
      }
    }
  }
`

export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`
